import { useRef, useState } from 'react'
import { useApplyListDetailsModel } from './applyListDetailsModel'
import Modal from 'antd/lib/modal/Modal'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { message } from 'antd'
import { ISelectOptions } from '@/types/AppTypes'
import useGlobalModel from '@/model/globalModel'
import { warehouseService } from '@/views/base/warehouseManage/warehouseService'
import { globalPrompt } from '@/components/message'
import { PlusSquareTwoTone } from '@ant-design/icons'
import { AddShelfModal } from '@/views/manage/assetsEntry/view/details/AddShelfModal'

export const ChangeWarehouseModel = ({ mode, visible, setVisible }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg, userList, userData, fetchUserList } = useGlobalModel()
    const { editGoodsList, addGoodsList, selectedKeys, setEditGoodsList, setAddGoodsList } = useApplyListDetailsModel()
    const [data, setData] = useState<any>({ warehouseCode: '', warehouseName: '', shelfCode: '' })
    const [shelfAllList, setShelfAllList] = useState<any>([])
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => {
            return { ...item, label: item.code as string, value: item.code, key: item.id }
        })
        setShelfAllList(newRecords)
    }
    const onOk = () => {
        globalPrompt('modal', {
            title: '',
            type: 'warning',
            text: '您是否批量调整仓库货位？',
            okText: '确认',
            onOk: () => {
                let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
                let newList: any = []
                dataSource.map((item) => {
                    if (selectedKeys.includes(item.detailsId)) {
                        newList.push({ ...item, ...data })
                    } else {
                        newList.push(item)
                    }
                })
                mode === 'edit' ? setEditGoodsList([...newList]) : setAddGoodsList([...newList])
                setVisible(false)
            },
            cancelText: '取消',
            onCancel: () => { },
        })
    }

    const formItem: IYhFormItemsBox = {
        title: '仓库货位批量调整',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '仓库',
                fieldName: 'warehouseCode',
                options: warehouseList,
                span: 24,
                onSelectChange: changeshelfCode,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span>
                    <PlusSquareTwoTone
                        twoToneColor="#1890ff"
                        style={{ cursor: 'pointer', margin: '0 5px' }}
                        onClick={() => {
                            if (!data.warehouseCode) {
                                message.error("请选择仓库")
                            } else {
                                handleOpenAddShelf()
                            }
                        }}
                    />货位</span>,
                fieldName: 'shelfCode',
                options: shelfAllList,
                span: 24,
            },
        ],
    }
    // 新增状态管理：控制货位添加弹窗
    const [addShelfVisible, setAddShelfVisible] = useState<boolean>(false);
    // 打开新增货位弹窗
    const handleOpenAddShelf = async () => {
        setAddShelfVisible(true);
    }
    const onChange = (changedValues: { [key: string]: any }) => {
        setData({
            ...data,
            ...changedValues,
            warehouseName: data.warehouseCode ? warehouseList.find((item) => item.value === data.warehouseCode)?.label : ''
        })
    }

    const FromConfig: IYhFormBox<any> = {
        labelAlign: 'right',
        formValues: data,
        onChange,
        boxs: [formItem],
    }
    // 新增货位成功后的回调
    const handleShelfAdded = (newShelf) => {
        // 将新货位添加到货位列表中
        setShelfAllList([...shelfAllList, newShelf]);
        // 自动选中新添加的货位
        setData({
            ...data,
            shelfCode: newShelf.value
        });
    }
    return (
        <Modal
            visible={visible}
            cancelText="取消"
            okText="确认"
            onCancel={() => {
                setVisible(false)
            }}
            onOk={onOk}
        >
            <YhFormBox {...FromConfig} />
            <AddShelfModal
                visible={addShelfVisible}
                warehouseCode={data.warehouseCode}
                onCancel={() => setAddShelfVisible(false)}
                onSuccess={handleShelfAdded}
            />
        </Modal>
    )
}
